import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'
import log from "@/components/login/index.vue";
import home from "@/components/home/index.vue";

Vue.use(Router);

export default new Router({
  mode: "history", //去掉#号
  routes: [
    {
      path: "/login",
      name: "login",
      component: resolve => require(["../components/login/index.vue"], resolve)
    },
    {
      path: "/",
      name: "home",
      component: resolve => require(["../components/home/index.vue"], resolve),
      children: [
        {
          path: "",
          name: "gyhw",
          component: resolve =>
            require(["../components/home/gyhw.vue"], resolve)
        },
        {
          path: "/hyyy",
          name: "hyyy",
          component: resolve =>
            require(["../components/home/hyyy.vue"], resolve)
        },
        {
          path: "/lxwm",
          name: "lxwm",
          component: resolve =>
            require(["../components/home/lxwm.vue"], resolve)
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js